<template>
    <div v-if="!item.hidden">
        <div v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
            <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
                <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">   
                   {{ onlyOneChild.meta.title }}
                </el-menu-item>
            </app-link>
        </div>
        <el-sub-menu   v-if="!(hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow)&&item.auth" ref="subMenu" :index="item.path" popper-append-to-body>
            <template #title v-if="item.meta">
                <img :src="'../../../../public/img/'+item.img" alt=""   class="iconimg">
                <span v-if="sidebar.opened"  class="metatitle">{{item.meta.title}}</span>
            </template>
            <div v-for="(child, index) in item.children"  :key="index"    >
                    <div>
                        <el-menu-item 
                        v-if="!child.hidden&&!child.children&&child.auth"
                        :key="child.path + index"
                        :index="child.path"
                        :route="child.path"
                        >           
                        <span  class="smalltitle">{{child.meta.title}}</span>
                    </el-menu-item>
                    <el-sub-menu :index="child.path"  v-if="!child.hidden&&child.children&&child.auth">
                        <template #title><span class="smalltitle">{{child.meta.title}}</span></template>
                        <div v-for="(ch,inx) in child.children" :key="ch.path+inx" >
                            <el-menu-item :index="inx"    :route="ch.path"  v-if="!ch.hidden&&ch.auth"  >
                                <span class="smalltitle">{{ ch.meta.title }}1</span>
                            </el-menu-item>
                        </div>
                        
                    </el-sub-menu>
                    </div>
            </div>
        </el-sub-menu>
    </div>
</template>
<script>
import { mapGetters} from "vuex";
import { isExternal } from '@/utils/validate';
import AppLink from './Link'
export default {
    name: 'SidebarItem',
    components: {AppLink},
    computed:{
        ...mapGetters(["sidebar"])
    },
    props: {
        // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        this.onlyOneChild = null
        return {}
    },
    methods: {
        isCollapse() {
                return !this.sidebar.opened;
        },
        showinfo(data){},
        hasOneShowingChild(children = [], parent) {
            if (!children) {
                children = []
            }
            const showingChildren = children.filter((item) => {
                if (item.hidden) {
                    return false
                } else {
                    this.onlyOneChild = item
                    return true
                }
            })
            if (showingChildren.length === 0) {
                this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
                return true
            }

            return false
        },
        resolvePath(routePath) {
            if (isExternal(routePath)) {
                return routePath
            }
            if (isExternal(this.basePath)) {
                return this.basePath
            }
        }
    }
}
</script>
<style>
.iconstyle{
    margin-right: 8px;
    font-size: 16px;
}
.metatitle{
    font-size: 14px;
}
.smalltitle{
    font-size: 12px;
}
.iconimg{
    width: 16px;
    height: 16px;
    margin-right: 4px;
}
</style>
